module.exports = __webpack_public_path__ + "static/media/GebietskarteProjektierung.43bb7cdf.pdf";